import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/core/services/api-services/user.service';

@Component({
  selector: 'app-add-user-promo',
  templateUrl: './add-user-promo.component.html',
  styleUrls: ['./add-user-promo.component.scss']
})
export class AddUserPromoComponent implements OnInit {

  form: FormGroup | any;
  isLoading: boolean = false;
  promoCodeList: any;
  progress_spinner: boolean = false
  userId: any;
  paginationObj: any = {
    // "page":0,
    // "per_page":8,
    // "search": '',
    // "searchBy": '',
    // 'totalItems' : 0
  }

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddUserPromoComponent>,
    public userService: UserService,
    public toast: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) { 
  }

  ngOnInit(): void {
    this.userId = this.props;
    this.initializeForm();
    this.getActivePromoCodeList()
  }

  initializeForm() {
    this.form = this.fb.group({
      user_id: new FormControl(this.userId),
      promo_code_id: new FormControl('', Validators.required),
    });
  }

  getActivePromoCodeList(){
    this.progress_spinner = true
    this.userService.getActivePromoCodeList(this.paginationObj).subscribe((res: any)=>{
      if(res.status == 200){
        this.progress_spinner = false
        this.promoCodeList = res.body.data
      }
    },
    err => {
      this.progress_spinner = false
    }
    )
  }

  formSubmit(){
    if( this.form.valid){
    let payload: any = {};
    payload =  this.form.value
    this.progress_spinner = true
    this.userService.addUserPromoCode(payload).subscribe((res:any)=>{
      if(res.body.success){
        this.progress_spinner = false
        this.dialogRef.close(true)
        this.toast.success(res.body.message);
      }else{
        this.toast.error(res.body.message);
        this.dialogRef.close(false)
        this.progress_spinner = false
      }
    },
    err => {
      this.toast.error(err.message);
      this.progress_spinner = false
    }
    )
  }else{
    this.toast.error('Please select promo code');
  }
  }


}
